var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container text-center"},[_c('home-content',{attrs:{"msg":"Welcome to District 10 Golf presented by The Great Lakes Junior Golf Tour"}}),_c('div',{staticClass:"my-4 text-right small text-muted"},[_vm._v("v. "+_vm._s(_vm.version))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }